import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { NEWS_POST_DELETED } from '../../store/news-post-actions';
import { NEWS_POST_LIST_ERROR, NEWS_POST_LIST_FETCH, NEWS_POST_LIST_RECEIVE } from './news-post-list-actions';
import { NewsPost } from '../../models/news-post';

export interface NewsPostListReducerState {
    items: PaginatedResponse<NewsPost>;
    requesting: boolean;
}

const initialNewsPostListReducerState: NewsPostListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const newsPostListReducer = (
    state: NewsPostListReducerState = initialNewsPostListReducerState,
    action: AnyAction
): NewsPostListReducerState => {
    switch (action.type) {
        case NEWS_POST_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case NEWS_POST_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['newsPosts'],
            };
        }

        case NEWS_POST_LIST_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case NEWS_POST_DELETED: {
            return {
                ...state,
                items: {
                    ...state.items,
                    items: state.items.items.filter(item => item.id !== action['id']),
                    total: state.items.total - 1,
                },
            };
        }

        default: {
            return state;
        }
    }
};
